import { createRouter, createWebHistory } from 'vue-router';
import RoutesBased from './routes-based';
import RoutesRenaissance from './routes-renaissance';
// Import jQuery
import $ from 'jquery';
window.jQuery = window.$ = $;

const routes = [
  ...RoutesBased,
  ...RoutesRenaissance
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else {
      return savedPosition;
    }
  },
  beforeEach(to, from, next) {
    // to and from are both route objects. must call `next`.
    // to remove any leftover modals
    $(".modal-backdrop").remove();
    next();
  }
})

export default router
